export default __webpack_public_path__ + "b934c7a.png";